import { connect } from "react-redux";
import { showModal } from "~/store/ducks/domain/ui/modal";

import Disclaimer from "./Disclaimer";

const mapDispatchToProps = {
  showModal
};

export default connect(null, mapDispatchToProps)(Disclaimer);
